import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';

const LOGO = 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6960b95861a068b7e8045644/963ec1955_WC360noBgColor.png';

export default function PublicShell({ children }) {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to={createPageUrl('LandingPage')}>
            <img src={LOGO} alt="World Check 360" className="h-8 w-auto" />
          </Link>
          <nav className="flex gap-6 text-sm font-medium text-slate-600">
            <Link to="/About" className="hover:text-slate-900">About</Link>
            <Link to="/Contact" className="hover:text-slate-900">Contact</Link>
          </nav>
        </div>
      </header>
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 py-12">{children}</main>
      <footer className="bg-slate-900 text-slate-400 text-center text-sm py-6">
        © {new Date().getFullYear()} World Check 360
      </footer>
    </div>
  );
}